import { useMediaQuery } from "@mui/material";

const useMediaByValue = (query: string) => {
  return useMediaQuery(query);
};

export default useMediaByValue;
